import { Grid } from "@mui/material";
import { Tile, TileProps } from "../components/Tile";
import { useNavigate } from "react-router-dom";
import AlertDialog from "../components/AlertDialog";
import { useContext, useState } from "react";
import englishTranslations from "../translations/en";
import { useCheckAccess } from "../hooks/useCheckAccess";
import { appContext } from "../context/AppContext";

export function AccountPageTiles() {
  const navigate = useNavigate();
  const context = useContext(appContext);
  const canUseDashboard = useCheckAccess("dashboard", context.user);
  
  const tiles: Array<TileProps> = [
    ...(canUseDashboard ? [{
      label: "Dashboards",
      icon: "ri-bar-chart-2-fill",
      onClick: () => setDashboardConfirmation(true),
    }] : []),
    {
      label: "Account CLT",
      icon: "ri-team-fill",
      onClick: () => navigate("/account/team-members"),
    },
    {
      label: "Hardware Security",
      icon: "ri-shield-check-fill",
      onClick: () => navigate("/account/hardware-security"),
    },
  ];

  const [dashboardConfirmation, setDashboardConfirmation] = useState(false);
  return (
    <Grid item container data-testid={"account-page-tiles"} xs={12} spacing={3}>
      {tiles.map((tileProps) => {
        return (
          <Grid item key={tileProps.label}>
            <Tile {...tileProps} />
          </Grid>
        );
      })}
      <AlertDialog
        title={englishTranslations.tileAction.dashboard.alert.title}
        content={englishTranslations.tileAction.dashboard.alert.body}
        isOpen={dashboardConfirmation}
        yesAction={() => navigate("/account/dashboards")}
        yesLabel={"Okay"}
        setIsOpen={setDashboardConfirmation}
        showNoButton={false}
      />
    </Grid>
  );
}
